import React from "react";
import { Chip, Box, Typography } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import EventNoteIcon from "@mui/icons-material/EventNote";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";

const monthNames = Array.from({ length: 12 }, (_, i) =>
  new Date(0, i).toLocaleString("default", { month: "long" })
);

export default function SummaryContextLabel({
  period = "month", // "month" | "year" | "all"
  month, // 0-indexed (0=Jan) if period === "month"
  year, // e.g. 2025
  sx = {},
}) {
  let label = "";
  let icon = <CalendarMonthIcon fontSize="small" sx={{ mr: 0.5 }} />;

  if (period === "month") {
    label = `${monthNames[month]} ${year}`;
    icon = <CalendarMonthIcon fontSize="small" sx={{ mr: 0.5 }} />;
  } else if (period === "year") {
    label = year;
    icon = <EventNoteIcon fontSize="small" sx={{ mr: 0.5 }} />;
  } else {
    label = "All Time";
    icon = <AllInclusiveIcon fontSize="small" sx={{ mr: 0.5 }} />;
  }

  return (
    <Box sx={{ mb: 1, ...sx }}>
      <Chip
        icon={icon}
        label={
          <Typography fontWeight={600} sx={{ letterSpacing: 0.2 }}>
            {period === "month"
              ? `Showing: ${label}`
              : period === "year"
              ? `Showing: ${label}`
              : "Showing: All Time"}
          </Typography>
        }
        sx={{
          background: "#f0f4ff",
          color: "#1e293b",
          fontWeight: 600,
          fontSize: 15,
          borderRadius: 2,
          px: 2,
          py: 1,
          boxShadow: "0 1px 4px #e0e7ff55",
          ...sx,
        }}
      />
    </Box>
  );
}
